import { motion } from "framer-motion";
import { Star, ArrowUpRight, MessageSquare } from "lucide-react";

const REVIEW_LINK = "https://g.page/r/Cf2k00l0Hh4zEBE/review";

// Drop new reviews at the top of this array — they'll render automatically.
// Fields: name, rating (1-5), date, text, city (optional)
const REVIEWS = [
  {
    name: "Todrick Burks",
    rating: 5,
    date: "5 days ago",
    text: "Amazing work. Very professional, detailed and courteous. Would certainly recommend.",
  },
  {
    name: "Alec",
    rating: 5,
    date: "2 weeks ago",
    text: "I can't say enough good things about Ricky and his crew. I've been working with them now since February on a massive project and he's always kept me up to speed and has gotten the job done. He's a hard working guy and I know I'll be calling RRR in the future when I need work done. Thanks Ricky!",
  },
  {
    name: "Mike Urquhart",
    rating: 5,
    date: "3 weeks ago",
    text: "We contracted with RRR to patch, caulk, paint and install chair rail in our living room, dining room, and an upstairs gallery. Repair and restoration included ceilings, walls and trim — and our living room ceilings are 25 feet high! Exceptionally large and challenging job — accomplished professionally, efficiently, and to a standard beyond our expectations. From the initial appointment with Ricky to the final clean-up with Richard (Ricky's Dad), the project was accomplished flawlessly. Friendly, always on time, seasoned workmanship. My wife and I couldn't be happier. I actually collected 3 bids and RRR was clearly the best prepared and most capable. Won't waste my time sorting through vendors again — RRR is going to be my first call.",
  },
  {
    name: "Remy A.",
    rating: 5,
    date: "1 month ago",
    text: "RRR Painting and Construction did a phenomenal job painting the exterior of my home. Ricky and his crew are extremely professional and very friendly.",
  },
  {
    name: "Beverly Hill",
    rating: 5,
    date: "2 months ago",
    text: "I highly recommend this company for all your painting and construction needs! Ricky, the CEO, and Trey, the team lead on our home, were timely, conscientious, and meticulous. They followed up and ensured the project remained on track! Job well done!",
  },
  {
    name: "Steve Holland",
    rating: 5,
    date: "3 months ago",
    text: "The crew from RRR were tremendously professional and their work met all my expectations. Ricky, Robert, and Tony were great. They used top-notch paint and their clean-up was amazing. I would recommend them anytime.",
  },
  {
    name: "Ellen Howard",
    rating: 5,
    date: "3 months ago",
    text: "RRR Paint & Construction did a great job for us at our house in Wetumpka, where we needed painting and replacement of rotten exterior wood. Ricky was very responsive and great to work with. His team came on time every day, even working on Saturday to finish the job. We're very satisfied with the results and would certainly use them again!",
  },
  {
    name: "Ashley Johnson",
    rating: 5,
    date: "4 months ago",
    text: "Rickey and Shawn did an amazing job painting my doors. They were professional, efficient, and paid attention to every detail. I'm very pleased with how everything turned out, and I will definitely be using them again!",
  },
  {
    name: "Deborah Steele",
    rating: 5,
    date: "5 months ago",
    text: "RRR Paint and Construction was prompt, courteous, and did a professional paint job. They left my home clean and in order.",
  },
  {
    name: "Lisa Woodbury",
    rating: 5,
    date: "6 months ago",
    text: "Such a great company — will definitely be hiring again. They take time and pride in their work.",
  },
  {
    name: "Jillian Marie",
    rating: 5,
    date: "6 months ago",
    text: "They did great and I will most definitely hire them again, and highly recommend them for jobs in the future.",
  },
  {
    name: "Diann Latham",
    rating: 5,
    date: "7 months ago",
    text: "Awesome job painting my home. No detail was missed. Ricky is great to work with — he listened and understood what I wanted done. Tony, his foreman, ensured the work was accomplished. I will definitely hire Ricky and his team again.",
  },
  {
    name: "Jerry Thomas",
    rating: 5,
    date: "8 months ago",
    text: "Very capable company at reasonable prices. Rick is very easy to work with and getting the job done asap and right is what is on his mind. Did our whole interior starting Monday and completing Saturday. Couldn't be more pleased!",
  },
  {
    name: "Tori Walton",
    rating: 5,
    date: "8 months ago",
    text: "I recently had my bedroom painted by R.R.R. Painting and Construction, and they did an outstanding job from start to finish. The team was punctual, professional, and incredibly detail-oriented. They took the time to prep the room properly, kept everything clean, and made sure the final result was flawless. The paint looks smooth and even, the edges are crisp, and the color came out exactly the way I envisioned. Extremely pleased with the quality of their work and customer service. I highly recommend them to anyone looking for reliable, top-notch painting professionals — definitely looking forward to working with Mr. Ricky on future projects!",
  },
  {
    name: "Michael House",
    rating: 5,
    date: "8 months ago",
    text: "I would highly recommend RRR Paint & Construction. Ricky and his team were very professional, and completed my project on time and as requested. I am pleased with the results.",
  },
  {
    name: "Chad Doster",
    rating: 5,
    date: "10 months ago",
    text: "Ricky was amazing and hassle-free to work with. We spoke about what I wanted painted and the expectations I had for quality of workmanship, then about the timeline I needed. We agreed on a price and BOOM — he did everything he said he would, when he said he would. I 100% recommend RRR Painting.",
  },
  {
    name: "Earl Moore",
    rating: 5,
    date: "11 months ago",
    text: "Outstanding performance in all aspects of customer and contractor relations. Performance A+++. Attitude A+++. Work getting complete A+++. Friendly & Helpful A+++.",
  },
];

function GoogleG({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.99.66-2.25 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
    </svg>
  );
}

function Stars({ n = 5 }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={`${n} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${i < n ? "fill-brand-blue text-brand-blue" : "text-brand-border"}`}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

function ReviewCard({ r, i }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay: i * 0.05, ease: [0.6, 0.05, 0.15, 1] }}
      data-testid={`review-card-${i}`}
      className="break-inside-avoid mb-4 border border-brand-border bg-brand-surface p-7 flex flex-col gap-5 hover:border-brand-blue transition-colors duration-500"
    >
      <div className="flex items-center justify-between">
        <GoogleG className="h-5 w-5" />
        <Stars n={r.rating || 5} />
      </div>
      <p className="text-white/90 text-base leading-relaxed">
        &ldquo;{r.text}&rdquo;
      </p>
      <div className="mt-auto pt-4 border-t border-brand-border flex items-baseline justify-between text-sm">
        <span className="font-display uppercase tracking-wider text-white">
          {r.name}
        </span>
        <span className="text-brand-muted text-xs uppercase tracking-widest">
          {[r.city, r.date].filter(Boolean).join(" · ")}
        </span>
      </div>
    </motion.article>
  );
}

function EmptyState() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.9 }}
      data-testid="reviews-empty"
      className="border border-brand-border bg-brand-surface p-10 md:p-16 flex flex-col items-start gap-6 max-w-3xl"
    >
      <div className="flex items-center gap-3">
        <GoogleG className="h-6 w-6" />
        <Stars n={5} />
      </div>
      <h3 className="font-display uppercase text-4xl md:text-6xl leading-[0.9]">
        Be our first <br />
        <span className="text-brand-blue">Google review.</span>
      </h3>
      <p className="text-brand-muted max-w-lg text-base md:text-lg">
        We just launched online — but we&apos;re not new to the work. If we&apos;ve
        painted for you before, we&rsquo;d be honored to earn a review. If not,
        book a free quote and we&rsquo;ll earn one the honest way.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 mt-2">
        <a
          href={REVIEW_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="leave-review-btn-empty"
          className="group inline-flex items-center gap-3 bg-brand-blue hover:bg-brand-blueHover text-white px-6 py-4 font-display tracking-wider uppercase text-lg transition-colors"
        >
          <GoogleG className="h-5 w-5" />
          Leave a Review
          <ArrowUpRight className="h-4 w-4 group-hover:rotate-45 transition-transform" />
        </a>
        <button
          onClick={() =>
            document.getElementById("lead-form")?.scrollIntoView({ behavior: "smooth" })
          }
          className="inline-flex items-center gap-3 border border-brand-border hover:border-white text-white px-6 py-4 font-display tracking-wider uppercase text-lg transition-colors"
        >
          <MessageSquare className="h-5 w-5" />
          Get a Free Quote
        </button>
      </div>
    </motion.div>
  );
}

export default function Reviews() {
  const hasReviews = REVIEWS.length > 0;
  const avg = hasReviews
    ? REVIEWS.reduce((a, r) => a + (r.rating || 5), 0) / REVIEWS.length
    : 0;

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-40 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-brand-muted mb-4 flex items-center gap-3">
              <span className="h-px w-8 bg-brand-blue" />
              06 — Reviews
            </div>
            <h2 className="font-display uppercase text-6xl md:text-8xl leading-[0.88]">
              What <span className="text-brand-blue">Neighbors</span> <br />
              Are Saying.
            </h2>
            {hasReviews && (
              <div className="mt-6 flex items-center gap-4">
                <Stars n={Math.round(avg)} />
                <span className="text-white text-sm">
                  <span className="font-display text-xl">{avg.toFixed(1)}</span>
                  <span className="text-brand-muted ml-2">
                    · {REVIEWS.length} Google review{REVIEWS.length !== 1 ? "s" : ""}
                  </span>
                </span>
              </div>
            )}
          </div>
          <a
            href={REVIEW_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leave-review-btn"
            className="group inline-flex items-center gap-3 bg-brand-blue hover:bg-brand-blueHover text-white px-6 py-4 font-display tracking-wider uppercase text-lg transition-colors self-start"
          >
            <GoogleG className="h-5 w-5" />
            Leave a Review
            <ArrowUpRight className="h-4 w-4 group-hover:rotate-45 transition-transform" />
          </a>
        </div>

        {hasReviews ? (
          <div className="columns-1 md:columns-2 lg:columns-3 gap-4">
            {REVIEWS.map((r, i) => (
              <ReviewCard key={i} r={r} i={i} />
            ))}
          </div>
        ) : (
          <EmptyState />
        )}
      </div>
    </section>
  );
}
